import { useQuery } from '@tanstack/react-query';

import { getVehiclesAutomataLogs, getVehiclesLogs } from '../queries/getVehicles.ts';
import { ProviderConfig } from '../schema/ProviderConfig.ts';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function addIndex(logs) {
  for (let i = 0; i < logs.length; i++) {
    logs[i].id = i;
  }
  return logs;
}

export const useAutomataLogs = (territorySlug: string, vehicleId: number) => {
  return useQuery({
    queryKey: ['automataLogs', territorySlug, vehicleId],
    queryFn: ({ signal }) => getVehiclesAutomataLogs(territorySlug, vehicleId, signal),
    refetchInterval: 10000,
    select: data => addIndex(data),
  });
};

export const useVehicleSystemLogs = (
  territorySlug: string,
  vehicleId: number,
  territoryConfig: ProviderConfig | null | undefined,
) => {
  return useQuery({
    queryKey: ['vehicleLogs', territorySlug, vehicleId],
    queryFn: ({ signal }) => getVehiclesLogs(territorySlug, vehicleId, signal),
    enabled: territoryConfig?.vehicle?.events_display === true,
    refetchInterval: 10000,
    select: data => addIndex(data),
  });
};
